import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Avatar, Rating } from '@mui/material';
import { 
  Star as StarIcon
} from '@mui/icons-material';

const testimonials = [
  {
    name: 'Sarah Chen',
    date: '2024-09-15',
    rating: 5,
    review: 'I had such a great experience at CHIHUI Mandarin Hub. The teachers are professional and patient, and the curriculum is well-structured. My Chinese has improved significantly in just 3 months. Highly recommended for anyone looking to learn Mandarin in Singapore!',
    avatar: 'SC'
  },
  {
    name: 'Michael Johnson',
    date: '2024-08-28',
    rating: 5,
    review: 'Excellent Mandarin learning experience! The online classes are very convenient and the teachers are native speakers with excellent English. The cultural immersion programs are particularly valuable for understanding Chinese business etiquette.',
    avatar: 'MJ'
  },
  {
    name: 'Lisa Wang',
    date: '2024-09-02',
    rating: 5,
    review: 'CHIHUI Mandarin Hub helped me prepare for my HSK exam successfully. The personalized approach and flexible scheduling made it easy to fit lessons into my busy schedule. The exam preparation course was comprehensive and effective.',
    avatar: 'LW'
  }
];

function ClientTestimonials() {
  return (
    <Box
      sx={{
        py: 12,
        bgcolor: 'white',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(45deg, rgba(7, 40, 75, 0.02) 0%, rgba(159, 33, 34, 0.01) 100%)',
          zIndex: 1
        }
      }}
    >
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2, px: { xs: 2, md: 4 } }}>
        {/* 标题区域 */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontFamily: 'serif',
              fontWeight: 700,
              color: '#07284b',
              mb: 4,
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              lineHeight: 1.2
            }}
          >
            What Our Clients Say ?
          </Typography>
        </Box>

        {/* 评价卡片网格 */}
        <Grid container spacing={4}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 16px 48px rgba(0,0,0,0.12)'
                  }
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  {/* 用户信息 */}
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar
                      sx={{
                        width: 50,
                        height: 50,
                        bgcolor: '#9f2122',
                        color: 'white',
                        fontSize: '1.2rem',
                        fontWeight: 700,
                        mr: 2
                      }}
                    >
                      {testimonial.avatar}
                    </Avatar>
                    <Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: '#07284b',
                          fontSize: '1.1rem'
                        }}
                      >
                        {testimonial.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#7f8c8d',
                          fontSize: '0.85rem'
                        }}
                      >
                        {testimonial.date}
                      </Typography>
                    </Box>
                  </Box>

                  {/* 评分 */}
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Rating
                      value={testimonial.rating}
                      readOnly
                      size="small"
                      sx={{
                        '& .MuiRating-iconFilled': {
                          color: '#ffc107'
                        }
                      }}
                    />
                    <StarIcon sx={{ color: '#2196f3', fontSize: '1rem', ml: 1 }} />
                  </Box>

                  {/* 评价内容 */}
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#34495e',
                      lineHeight: 1.6,
                      fontSize: '0.95rem',
                      mb: 2
                    }}
                  >
                    {testimonial.review}
                  </Typography>

                  {/* 阅读更多链接 */}
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#9f2122',
                      fontSize: '0.85rem',
                      cursor: 'pointer',
                      '&:hover': {
                        textDecoration: 'underline'
                      }
                    }}
                  >
                    Read more
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default ClientTestimonials;
